import * as types from "./mutation-types";
import vuetify from "../plugins/vuetify";
import Vue from 'vue';
export default {
  [types.LOADING](state) {
    state.loading = true;
  },
  [types.LOADED](state)
  {
    state.loading = false;
  },
  [types.LOGIN](state)
  {
    state.isLoggedIn = true;
  },
  [types.LOGOUT](state)
  {
    state.isLoggedIn = false;
  },
  [types.TOGGLEDARK](state)
  {
    var isDark = localStorage.getItem("isDark") == 'true';
    localStorage.setItem("isDark", !isDark);
    state.isDark = !isDark;
  }

};
